import LockIcon from '@mui/icons-material/Lock';
import { Box, Button, Typography } from '@mui/material';
import { useRouter } from '@tanstack/react-router';
import type { FC, JSX } from 'react';

import type { TRouteErrorProps } from '../types';

export const AuthError: FC<TRouteErrorProps> = (): JSX.Element => {
  const router = useRouter();

  const handleSignIn = (): void => {
    void router.navigate({ to: '/sign-in' });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="50vh"
      gap={4}
      p={4}
      textAlign="center"
    >
      <LockIcon sx={{ fontSize: 64, color: 'custom.textGrey' }} />
      <Typography variant="h2">Session Expired</Typography>
      <Typography variant="body1" color="custom.textGrey">
        Your session has expired. Please sign in again.
      </Typography>
      <Button variant="contained" onClick={handleSignIn}>
        Sign In
      </Button>
    </Box>
  );
};
